<template>
  <header class="position-sticky top-0" :class="[ isDarkMode? 'dark-mode' : 'bg-white']" style="z-index: 999">
    <!-- Navbar -->
    <nav class="navbar navbar-expand-lg navbar-light">
      <!-- Container wrapper -->
      <div class="container-fluid px-24">
        <a
          class="header-left navbar-brand mt-2 mt-lg-0 remove-share"
          href="/"
          style="margin-left: 0.5rem"
        >
          <img
            :src="isDarkMode ? logoWhite : dashboardLogo"
            width="168"
            height="32"
            alt="SCANAT Logo"
            loading="lazy"
          />
        </a>
        <!-- Right elements -->
        <div
          id="model_detail_header"
          class="header-right d-flex align-items-center"
          style="margin-right: 1.25rem"
        >
          <LanguageSwitcher :isDarkMode="isDarkMode" />

          <ul
            class="navbar-nav me-auto mb-0 login-area flex-row align-items-center d-none"
            style="gap: 2rem"
          >
            <li class="nav-item">
              <a class="nav-link fw-bold text-primary home-login check-share" href="login.html"
                >{{ $t('login.login') }}</a
              >
            </li>
            <li class="nav-item">
              <button
                class="fw-bold text-primary bg-white fs-14 home-register check-share"
                style="border: 1px solid #0068b0; border-radius: 4px; padding: 0.5rem 1rem"
                onclick='window.location.href="./login.html?signup=true"'
              >
                {{ $t('login.register')}}
              </button>
            </li>
          </ul>
          <!-- Avatar -->
          <div class="dropdown avatar-area">
            <a
              class="dropdown-toggle d-flex align-items-center hidden-arrow gap-3"
              href="#"
              id="navbarDropdownMenuAvatar"
              role="button"
              data-mdb-toggle="dropdown"
              data-mdb-display="static"
              data-mdb-dropdown-animation="off"
            >
              <img
                src="../../../assets/default-user.png"
                class="rounded-circle"
                height="32"
                width="32"
                alt="Black and White Portrait of a Man"
                loading="lazy"
              />

              <span
                style="font-weight: 500; font-size: 0.875rem; color: #16191e"
                class="customer-name"
              >
                -
              </span>
            </a>
            <ul
              class="dropdown-menu dropdown-menu-end mt-10"
              aria-labelledby="navbarDropdownMenuAvatar"
              style="
                border: 1px solid #dadada;
                box-shadow: 0 10px 32px 0 #00365b1a;
                border-radius: 0.5rem;
                padding: 0.75rem 1rem 1rem;
                min-width: 12.5rem;
              "
            >
              <li
                class="d-flex gap-12"
                style="color: #16191e; padding-bottom: 0.75rem; border-bottom: 1px solid #00365b14"
              >
                <span>ID</span>
                <span class="customer-id" style="overflow-wrap: break-word; color: #00426f">-</span>
              </li>
              <li
                style="padding-bottom: 0.75rem; padding-top: 0.75rem"
                class="d-flex gap-12 cursor-pointer align-items-center mt-8 navbar-item navbar-web remove-share"
              >
                <img src="../../../assets/icons/web.svg" alt="web" class="icon-16" />
                <span class="fs-14 text-335e7c">{{ $t('landing.scanatWeb') }}</span>
              </li>
              <li
                style="padding-bottom: 0.75rem; padding-top: 0.75rem"
                class="d-flex gap-12 cursor-pointer align-items-center mb-8px navbar-item navbar-dashboard remove-share"
              >
                <img src="../../../assets/icons/dashboard.svg" alt="dashboard" class="icon-16" />
                <span class="fs-14 text-335e7c">{{ $t('landing.idManage') }}</span>
              </li>
              <li class="text-center">
                <button
                  type="button"
                  class="btn-outline-primary btn btn-logout w-100"
                  data-mdb-ripple-color="dark"
                  style="
                    font-weight: 500;
                    font-size: 0.875rem;
                    border: 1px solid #0068b0;
                    border-radius: 6px;
                    padding: 5px 1rem;
                    color: #0068b0;
                  "
                >
                  {{ $t('login.logout') }}
                </button>
              </li>
            </ul>
          </div>
        </div>
        <!-- Right elements -->
      </div>
      <!-- Container wrapper -->
    </nav>
    <!-- Navbar -->
  </header>
  <ModalNoPermission />
</template>

<script setup>
import LanguageSwitcher from './LanguageSwitcher.vue'
import ModalNoPermission from './ModalNoPermission.vue';
import dashboardLogo from 'url:../../../assets/dashboard-logo.svg'
import logoWhite from 'url:../../../assets/models/logo-white.svg'

defineProps({
  isDarkMode: {
    type: Boolean,
    default: false
  }
})
</script>

<style scoped>
</style>

